import { render, staticRenderFns } from "./nutritionalNeeds.html?vue&type=template&id=70537309&scoped=true&"
import script from "./nutritionalNeeds.js?vue&type=script&lang=js&"
export * from "./nutritionalNeeds.js?vue&type=script&lang=js&"
import style0 from "./nutritionalNeeds.scss?vue&type=style&index=0&id=70537309&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70537309",
  null
  
)

export default component.exports